/**
 * Limpia espacios innecesarios al perder foco o en submit.
 */
export const normalizeInputOnBlur = ({ value, setValue, fieldName }) => {
  const cleaned = value
    .split('\n') // Dividir por líneas
    .map(line => line.replace(/\s+/g, ' ').trim()) // Limpiar cada línea individualmente
    .join('\n') // Volver a unir con saltos de línea
    .replace(/\n\s*\n/g, '\n\n') // Normalizar múltiples saltos de línea consecutivos a máximo 2
    .trim(); // Eliminar espacios al inicio y final del texto completo

  setValue(fieldName, cleaned, { shouldDirty: true });
};
